export default __webpack_public_path__ + "static/media/intro_rewind.bfa974e4.pdf";